import LocalizationStore from '../Stores/LocalizationStore'
import { Merchant } from './MerchantModel'
import AffiliatesStore from '../Stores/AffiliatesStore'
import * as React from 'react'
import ReactTable, { CellInfo } from 'react-table'
import Form, { ISubmitEvent, FormValidation, AjvError } from 'react-jsonschema-form'
import { Button } from 'react-bootstrap'
import UserStore from '../Stores/UserStore'
import { Link } from 'react-router-dom'
import MerchantsStore from '../Stores/MerchantsStore'
import HttpActionsService from '../Services/HttpActionsService'
import { history } from '../Routing'
import { filterMethod } from '../Helpers/ReactTableHelper'
import ConfigStore from '../Stores/ConfigStore'
import * as FontAwesome from 'react-icons/lib/fa'

const ls = LocalizationStore.getInstance()

export class Affiliate {
    id: string
    name: string
    isActive: boolean
    merchant: Merchant
}

export class AffiliateTableModel {

    constructor(affiliate: Affiliate) {
        this.id = affiliate.id
        this.name = affiliate.name
        this.isActive = affiliate.isActive ? ls.t('Active') : ls.t('Not Active')
        this.merchantId = affiliate.merchant.id
        this.merchantName = affiliate.merchant.name
        this.merchantIsActive = affiliate.merchant.isActive ? ls.t('Active') : ls.t('Not Active')
    }

    id: string
    name: string
    isActive: string
    merchantId: string
    merchantName: string
    merchantIsActive: string
}

export function getAffiliatesColumns() {
    return [
        {
            Header: ls!.t('id'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'id',
            sortable: false,
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="affiliateDetailLink"
                    to={'/affiliate/' + cellInfo.row.id}
                    id={cellInfo.row.name}
                >
                    {cellInfo.row.id}
                </Link>
            ),
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'id')
        },
        {
            Header: ls!.t('Name'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'name',
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'name')
        },
        {
            Header: ls!.t('isActive'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'isActive',
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'isActive')
        },
        {
            Header: `${ls!.t('Merchant')} ${ls!.t('id')}`,
            maxWidth: 400,
            minWidth: 90,
            accessor: 'merchantId',
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'merchantId')
        },
        {
            Header: `${ls!.t('Merchant')}  (${ls!.t('observation')})`,
            maxWidth: 400,
            minWidth: 90,
            accessor: 'merchantName',
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'merchantName')
        },
        {
            Header: `${ls!.t('Merchant')} ${ls!.t('isActive')}`,
            maxWidth: 400,
            minWidth: 90,
            accessor: 'merchantIsActive',
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'merchantIsActive')
        }
    ]
}

export function getAffiliateFormScheme(affiliate: Affiliate, merchants: Array<Merchant>): any {

    let defaultMerchant = ''

    if (affiliate && affiliate.merchant) {
        defaultMerchant = merchants.filter(x => x.id === affiliate.merchant.id)[0].id
    }

    return {
        type: 'object',
        required: [
            'name',
            // 'isActive',
            // 'merchant'
        ],
        properties: {
            id: {
                type: 'string'
            },
            name: {
                type: 'string'
            },
            isActive: {
                type: 'boolean',
                title: ls.t('isActive')
            },
            merchant: {
                title: ' ',
                type: 'object',
                properties: {
                    id: {
                        title: ' ', // `${ls.t('Current')} ${ls.t('id')}`,
                        type: 'string'
                    },
                    merchantList: {
                        title: ' ',
                        type: 'object',
                        properties: {
                            merchantId: {
                                title: `${ls.t('selectMerchant')}`,
                                type: 'string',
                                enum: merchants.map(x => x.id),
                                enumNames: merchants
                                    .map(x =>
                                        `${x.id} ${x.name} [${x.isActive ? ls.t('Active') : ls.t('Not Active')}]`
                                    ),
                                default: defaultMerchant,
                                uniqueItems: true
                            },
                        }
                    }
                }
            },
        }
    }
}

export function getAffiliateFormUIScheme(merchants: Array<Merchant>) {
    return {
        'id': {
            'ui:readonly': true,
            'ui:help': ls.t('uneditable'),
        },
        'merchant': {
            id: {
                'ui:readonly': true,
                'ui:widget': (props: any) => {
                    return (
                        <Link
                            className="btn"
                            to={`/merchant/${props.value}`}
                        >
                            <FontAwesome.FaExternalLink
                                color="white"
                            /> {ls.t!('Merchant')}
                            {/* {props.value} */}
                        </Link>
                    )
                }
            },
            merchantList:
            {
                merchantId: {
                    'ui:enumDisabled': merchants.filter(x => !x.isActive).map(x => x.id),
                }
            }
        }
    }
}

export function createStub(data: Array<Affiliate>) {
    return data.map(x => new AffiliateTableModel(x))
}

export function createOrUpdateAffiliate(e: ISubmitEvent<any>) {
    var affiliate = new Affiliate()
    var merchant = new Merchant()
    merchant.id = e.formData.merchant.merchantList.merchantId

    affiliate.id = e.formData.id
    affiliate.isActive = e.formData.isActive
    affiliate.name = e.formData.name
    affiliate.merchant = merchant

    if (affiliate.id) {
        HttpActionsService.getInstance().updateAffiliate(affiliate)
    } else {
        HttpActionsService.getInstance().createAffiliate(affiliate)
    }
}

export function validateAffiliateForm(formData: any, errors: FormValidation) {
    if (!formData.name) {
        errors['affiliate']['name'].addError('Invalid name')
    }

    // if (!formData.merchant.id) {
    //     errors.merchant['id'].addError(ls.t('Invalid merchant id'))
    // }

    return errors
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['name'] === 'required') {
            error['message'] = ls.t('is a required property')
        }
        if (error['params']['type'] === 'number') {
            error['message'] = ls.t('should be number')
        }
        if (error['message'] === 'should be equal to one of the allowed values') {
            error['message'] = ls.t('should be equal to one of the allowed values')
        }
        return error
    })
}

export function getAffiliatesTable() {
    const localizationStore = LocalizationStore.getInstance()
    const affiliatesStore = AffiliatesStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            data={createStub(affiliatesStore.getList)}
            columns={getAffiliatesColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}

        />
    )
}

export function getAffiliateForm() {
    const localizationStore = LocalizationStore.getInstance()
    const affiliatesStore = AffiliatesStore.getInstance()
    const userStore = UserStore.getInstance()
    const merchantsStore = MerchantsStore.getInstance()
    if (!affiliatesStore.getItem) {
        return (
            <div>
                <p>{localizationStore.t('no data')}</p>
                <Button
                    onClick={() => { history.push('/affiliates') }}
                >
                    {localizationStore!.t!('backToList')}
                </Button>
            </div>
        )
    }

    let affiliate = affiliatesStore.getItem
    let merchants = merchantsStore.getList

    return (
        <Form
            schema={getAffiliateFormScheme(affiliate, merchants)}
            uiSchema={getAffiliateFormUIScheme(merchants)}
            onSubmit={(e) => createOrUpdateAffiliate(e)}
            formData={affiliate}
            validate={validateAffiliateForm}
            transformErrors={transformErrors}
        >
            <div className="affiliateFormBtns">
                <Button
                    hidden={!(userStore.checkAdmin || userStore.checkSuperAdmin)}
                    type="submit"
                >
                    {localizationStore!.t!('Save')}
                </Button>
                <Button
                    onClick={() => { history.push('/affiliates') }}
                >
                    {localizationStore!.t!('backToList')}
                </Button>
            </div>
        </Form>
    )
}

export function getDefaultAffiliate() {
    let notSetLocalized = LocalizationStore.getInstance().t('notSet')

    let defaultAffiliate = new Affiliate()
    defaultAffiliate.id = '00000000-0000-0000-0000-000000000000'
    defaultAffiliate.isActive = true
    defaultAffiliate.name = notSetLocalized
    defaultAffiliate.merchant = new Merchant()
    defaultAffiliate.merchant.id = '00000000-0000-0000-0000-000000000000'
    defaultAffiliate.merchant.name = notSetLocalized
    defaultAffiliate.merchant.isActive = true

    return defaultAffiliate
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/AffiliateModel.tsx